export const streamParticipationTypeOptions = [
    { value: 'online', label: 'Online' },
    { value: 'offline', label: 'Offline' },
    { value: 'hybrid', label: 'Гибрид' },
    { value: 'hidden', label: 'Скрывать зал' },
];

export const archiveStatusTitles = {
    'none': 'Нет',
    'idle': 'В очереди',
    'process': 'Архивируется',
    'done': 'Готово',
    'file': 'Файл',
    'fail': 'Ошибка'
};

export const transcoderPresets = {
    1: { bitrate: 800, width: 854, height: 480 },
    2: { bitrate: 2000, width: 1280, height: 720 },
    3: { bitrate: 3000, width: 1920, height: 1080 },
};

export const bitrateOptions = [50, 100, 200, 350, 500, 650, 800, 950, 1000, 1200, 1500, 1800, 2000, 2500, 3000, 4000, 5000, 6000, 8000, 10000, 14000].map(value => ({ value, label: value }));

export const defaultLanguages = (streamID) => ({
    left: { stream_id: streamID, channel: 'left', label: 'RU', description: 'Русский', enabled: false, 'default': true },
    right: { stream_id: streamID, channel: 'right', label: 'EN', description: 'English', enabled: false, 'default': false },
});